import React from "react";
import { useNavigate } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
import { tierFor, formatDate } from "@/lib/utils-app";
import { Play } from "lucide-react";

export function HistoryCard({ analysis }) {
  const navigate = useNavigate();
  const meta = analysis.metadata || {};
  const tier = tierFor(analysis.overall_score || 0);

  return (
    <button
      onClick={() => navigate(`/analysis/${analysis.id}`)}
      className="group text-left rounded-xl border border-border bg-card overflow-hidden hover:border-primary/50 transition-colors"
      data-testid="history-card"
    >
      <div className="relative aspect-video bg-muted overflow-hidden">
        <img
          src={meta.thumbnail}
          alt={meta.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-colors flex items-center justify-center">
          <span className="opacity-0 group-hover:opacity-100 transition-opacity h-10 w-10 rounded-full bg-primary text-primary-foreground flex items-center justify-center">
            <Play className="h-4 w-4 ml-0.5" />
          </span>
        </div>
        <Badge className="absolute top-2 left-2 border-0 bg-black/70 text-white">
          {meta.video_type === "short" ? "Short" : "Video"}
        </Badge>
        <span
          className="absolute top-2 right-2 h-9 w-9 rounded-full flex items-center justify-center text-xs font-bold tabular"
          style={{ backgroundColor: tier.color, color: "#fff" }}
        >
          {analysis.overall_score}
        </span>
      </div>
      <div className="p-3.5">
        <h4 className="text-sm font-medium leading-snug line-clamp-2">{meta.title}</h4>
        <div className="mt-1.5 flex items-center justify-between text-xs text-muted-foreground">
          <span className="truncate max-w-[60%]">{meta.channel}</span>
          <span>{formatDate(analysis.created_at)}</span>
        </div>
      </div>
    </button>
  );
}
